var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2843 3.81995L19.1801 7.71567M12.6872 22H23.0758M2.29858 16.8057L1 22L6.1943 20.7014L21.2396 5.65614C21.7265 5.1691 22 4.50862 22 3.81995C22 3.13128 21.7265 2.4708 21.2396 1.98377L21.0162 1.76041C20.5292 1.27352 19.8687 1 19.1801 1C18.4914 1 17.8309 1.27352 17.3439 1.76041L2.29858 16.8057Z",
    stroke: "white",
    strokeWidth: 1.94786,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.32fa4240fb08b2aa7b0f79e3ba2a1497.svg";
export { ForwardRef as ReactComponent };